import {useFilterIssue} from './useFilterIssue';
import {useCreateFilters} from '../useCreateFilters';
import {FilterState} from '../../modules/issues/filter/IssueFilters';
import {API_PARAMS} from '../../constants/constants';
import {OptionItem, PaginationState} from '../../types';

// Custom hook to handle issues data fetching and filter options.
export const useIssuesData = (
  filters: FilterState,
  pagination: PaginationState,
  enabled = true
) => {
  // Full, unfiltered set of filter options. The filter selects bind to this so
  // every group and every value stays available regardless of the active
  // filters (the search aggregations would otherwise collapse the option list).
  const {
    data: issueOptions = new Map<string, OptionItem[]>(),
    isLoading: isLoadingOptions
  } = useCreateFilters({
    valueFind: API_PARAMS.OPTIONS.ISSUE_VALUE_FIND
  });

  // Build search criteria for API call
  const searchCriteria = {

    searchText: filters.searchText || undefined,

    // Send options as an array of OptionItem objects with key-value pairs
    options: filters.options.length > 0 ? filters.options.map(option => {
      const name = option.abbreviation || option.identified || option.name || 'unknown';
      const value = option.id || option.value || option.description || '';
      return {name: name, value: value};
    }) : undefined,

    createdDateFrom: filters.dateRange?.[0] || undefined,
    createdDateTo: filters.dateRange?.[1] || undefined,
    offset: (pagination.current - 1) * pagination.pageSize,
    limit: pagination.pageSize,
    hasFilters: filters.hasFilters
  };

  // Search API call
  const {
    data: searchResponse,
    isLoading: isSearchLoading,
    isError: isSearchError,
    error: searchError,
    refetch: refetchSearch
  } = useFilterIssue(searchCriteria, {enabled});

  const totalCount = searchResponse?.totalCount || 0;
  const searchResults = searchResponse?.data || [];

  return {
    // Data
    searchResults,
    totalCount,
    issueOptions,

    // Loading states
    isSearchLoading,
    isLoadingOptions,

    // Error states
    isSearchError,
    searchError,

    // Functions
    refetchSearch
  };
};
